// Scripts librairies
import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')

docReady(function () {
  // auto-anchor
  const target = document.getElementById('article-detail')
  if (target) {
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth' })
    }, 800)
  }

  // auto-anchor
  const target2 = document.getElementById('nos-realisations')
  if (target2) {
    setTimeout(() => {
      target2.scrollIntoView({ behavior: 'smooth' })
    }, 800)
  }
})
